let API_URL = 'https://inris-online.com/api';

if (process.env.NODE_ENV === "development") {
  //API_URL = 'http://127.0.0.1:8000/api';
  API_URL = 'https://inris-online.com/api';
  // API_URL = 'http://preprod.inris-online.com/api';
}
if (process.env.NODE_ENV === "production") {
  if(window.location.hostname === "preprod-eleve.inris-online.com") {
    API_URL = 'https://inris-online.com/api';
  }
  if(window.location.hostname === "clients.inris-online.com") {
    API_URL = 'https://inris-online.com/api';
  }
}
const config = {
  apiUrl: API_URL,
};

export default config;
